import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ToastContainer } from 'react-toastify';
import {
  HomePage,
  AboutPage,
  FeaturesPage,
  PrivacyPage,
  TermsPage,
  ContactPage,
  NamePage,
  BlogPage,
  BabyNamesPage
} from './routes';
import 'react-toastify/dist/ReactToastify.css';

export default function App() {
  return (
    <HelmetProvider>
      <Router>
        <ToastContainer position="top-right" />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/features" element={<FeaturesPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/name/:nameSlug" element={<NamePage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/baby-names" element={<BabyNamesPage />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}